function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 28,
  fill: "#DCD8BF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 37.517c.854-1.277 2.131-4.262 2.558-7.67.427-3.41 1.277-6.391 2.982-8.096 1.704-1.704 3.835-2.558 6.39-2.558 2.602 0 5.964 1.278 6.39 3.836 1.279-2.555 1.705-4.474 2.132-7.032.85.426 2.343 1.492 2.982 1.916-1.704 1.704-2.982 3.409-4.262 5.54 2.558-.427 5.54 2.13 5.54 6.39 0 3.194-.851 6.39-4.26 7.671-.07.026 1.016-.897.85-2.558-.211-2.13-1.703-3.408-3.835-3.408-2.13 0-4.047 1.704-4.047 4.047 0 2.555 1.916 3.62 4.047 3.62-3.405 1.71-12.78.86-17.467-1.698z",
  fill: "#938666"
});

var SvgEmptyItem = function SvgEmptyItem(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyItem, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-item.5d1f1d61.svg";
export { ForwardRef as ReactComponent };